The URL of the image, e.g. `https://integration.seek.com/awsk/button-images/seek/en/light.svg`.
